import { render } from "./NotaryComponent.vue?vue&type=template&id=576fce41&scoped=true"
import script from "./NotaryComponent.vue?vue&type=script&lang=js"
export * from "./NotaryComponent.vue?vue&type=script&lang=js"

import "./NotaryComponent.vue?vue&type=style&index=0&id=576fce41&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576fce41"]])

export default __exports__